import React from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';

import {isSubmitting, submit} from 'redux-form';

import {formatDate} from 'utils/datetime';

import {default as Modal, withModal} from 'components/Modal';

import {MODALS, selectXeroOrganisation} from 'ducks/tenancy/detail';

import Buttons from './components/Buttons';
import OverpaymentCreateForm from './components/OverpaymentCreateForm';

import './styles.css';

class OverpaymentCreateModal extends React.Component<any> {
  triggerFormSubmit = () => {
    this.props.submit('overpaymentCreate');
  };

  getExtraActions = ({scheduleType}) => {
    let extraActions = [
      ...this.props.closeModalExtraActions,
      ...this.props.refetchExtraActions({
        tenancyId: this.props.data.tenancyId,
        scheduleType
      })
    ];

    if (!_.isNil(this.props.closeModalSuccessExtraActions)) {
      extraActions.push(this.props.closeModalSuccessExtraActions);
    }

    return extraActions;
  };

  render() {
    const {
      data: {
        scheduleType,
        locationRef,
        tenancyId,
        openFromBookingSet,
        booking,
        primaryTenant
      },
      xeroOrganisation,
      form: {submitting}
    } = this.props;
    const cutOffDate = _.get(xeroOrganisation, 'cutOffDate');

    return (
      <Modal
        show={true}
        type={Modal.EXTRA_SMALL}
        onClose={this.props.closeModal}
        className="OverpaymentCreateModal">
        <Modal.Header>
          <h3 className="header">Create Overpayment</h3>
          <div className="subHeader">
            Cut off date: {cutOffDate && formatDate(cutOffDate)}
          </div>
        </Modal.Header>
        <Modal.Body>
          <OverpaymentCreateForm
            delayExtraActions={this.props.delayExtraActions}
            tenancyId={tenancyId}
            scheduleType={scheduleType}
            locationRef={locationRef}
            getExtraActions={this.getExtraActions}
            storeDataExtraActions={this.props.storeDataExtraActions}
            openFromBookingSet={openFromBookingSet}
            primaryTenant={primaryTenant}
            booking={booking}
          />
        </Modal.Body>
        <Modal.Footer>
          <Buttons
            triggerSubmit={this.triggerFormSubmit}
            submitting={submitting}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const formName = 'overpaymentCreate';

  return {
    xeroOrganisation: selectXeroOrganisation(state),
    form: {
      submitting: isSubmitting(formName)(state)
    }
  };
};

const mapDispatchToProps = {
  submit
};

export default withModal(MODALS.OVERPAYMENT_CREATE)(
  connect(mapStateToProps, mapDispatchToProps)(OverpaymentCreateModal)
);
